import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable()
export class AuthStorageService implements AbstractSecurityStorage {
  read(key: string): string | null {
    Preferences.get({ key });
    return localStorage.getItem(key);
  }

  write(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
